import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** The class merger every shadcn component expects at the `utils` alias in components.json.
 *
 *  It is not a cosmetic helper: `twMerge` resolves CONFLICTS between Tailwind utilities by keeping the
 *  last one, which is what makes a component's `className` prop able to override the component's own
 *  defaults. Template-literal concatenation — the pattern the hand-written kit uses — emits both classes
 *  and leaves the winner to source order in the stylesheet, so a caller passing `px-2` to something built
 *  with `px-3` gets whichever Tailwind happened to emit last. Every component ported to shadcn composes
 *  its classes through here for that reason. */
/** The merger has to know this app's own type scale. It recognises `text-sm` as a SIZE only because the
 *  size is Tailwind's; a `--text-*` step from app/styles/tokens.css (`text-meta`, `text-small`, …) it
 *  would read as a text COLOUR, and then drop it as soon as a real colour followed — `text-meta
 *  text-muted-foreground` merged to the colour alone and the line rendered at body size. The names are
 *  the token names; tests/lib/utils.test.ts holds this list to tokens.css. */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'page-title', 'section-title', 'card-title', 'ui', 'meta', 'small', 'figure', 'body', 'conversation', 'display',
        'lead', 'eyebrow', 'emphasis', 'small-emphasis', 'code',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
